module.exports = __webpack_public_path__ + "img/bg1-min.40790a09.jpg";